module.exports = __webpack_public_path__ + "img/barcode1.ea71ec35.png";